import { mapStackTrace } from 'sourcemapped-stacktrace';
import { segmentEvent } from 'services/segment';
import { useDataLogsStore } from 'store/modules';

export const mapStackTraceError = async (stack) => {
    stack = !stack ? '' : stack;

    return new Promise((resolve) => {
        mapStackTrace(stack, function (mappedStack) {
            resolve(mappedStack.join('\n'));
        });
    });
};

export const errorHandler = (err, file, method = '') => {
    const dataLogsStore = useDataLogsStore();

    if (err instanceof Error) {
        dataLogsStore.setLogItem({
            logLevel: 'error',
            message: err.message,
            details: {
                trace: err.stack,
            },
        });
    }

    const disabledSegmentEventLog = true;

    if (disabledSegmentEventLog) {
        if (file) {
            if (method) {
                console.error(`Error - ${err.message} | ${err.stack} | ${file} | ${method}`);
            } else {
                console.error(`Error - ${err.message} | ${err.stack} | ${file}`);
            }
        } else {
            console.error(`Error - ${err.message} | ${err.stack}`);
        }
    } else {
        if (err instanceof Error) {
            try {
                mapStackTraceError(err.stack).then((stack) => {
                    const payload = {
                        app: 'VUE',
                        origin: window.location.origin,
                        href: window.location.href,
                        message: err.message,
                        stack: stack,
                    };

                    if (file) {
                        payload.file = file;

                        if (method) {
                            console.error(
                                `Error - ${err.message} | ${stack} | ${payload.file} | ${method}`
                            );
                        } else {
                            console.error(`Error - ${err.message} | ${stack} | ${payload.file}`);
                        }
                    } else {
                        console.error(`Error - ${err.message} | ${stack}`);
                    }

                    segmentEvent('ERROR_JS', payload);
                });
            } catch (e) {
                console.error(e);
            }
        }
    }
};

export const globalWatchError = () => {
    window.onerror = function (message, url, line, col, err) {
        if (err) {
            errorHandler(err);
        }
    };
};

export const loggerVue = {
    error: (e, file, method) => {
        errorHandler(e, file, method);
    },
    info: (e, file, method) => {
        errorHandler(e, file, method);
    },
};
